<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Véhicules",
          icon: "bi bi-car-front-fill",
          route: "vehicles-index",
        },
        {
          label: "Nouveau véhicule",
          icon: "bi bi-plus-circle-fill",
          route: "vehicles-create",
        },
      ],
    };
  },
};
</script>
